export const LOGIN = {
  REQUIRED_ID: '아이디를 입력해주세요',
  REQUIRED_PW: '패스워드를 입력해주세요.',
};
